import { RedemptionChannelRequestModel } from "libs/models/branches";
import { ValidationModel } from "libs/models/validate-model";
import { RedemptionChannelStore } from "store/slices/redemption-channel";
import translate from "utils/translations";

export const ValidateEditRedemptionChannelState = (
  state: RedemptionChannelStore
): ValidationModel<RedemptionChannelRequestModel> => {
  let validationModel = {} as ValidationModel<RedemptionChannelRequestModel>;
  if (!state.isValidating) {
    return validationModel;
  }
  if (
    state.updateRedemptionChannelData.street === null ||
    state.updateRedemptionChannelData.street === ""
  ) {
    validationModel.street = translate(
      "Required_Text",
      "This field is required"
    );
  }

  if (
    state.updateRedemptionChannelData.buildingNumber === null ||
    state.updateRedemptionChannelData.buildingNumber === ""
  ) {
    validationModel.buildingNumber = translate(
      "Required_Text",
      "This field is required"
    );
  }
  if (
    state.updateRedemptionChannelData.contactNumber === null ||
    state.updateRedemptionChannelData.contactNumber === ""
  ) {
    validationModel.contactNumber = translate(
      "Required_Text",
      "This field is required"
    );
  }
  const phoneRegex = /^\d{4,11}$/;
  if (
    state.updateRedemptionChannelData.contactNumber !== "" &&
    !phoneRegex.test(state.updateRedemptionChannelData.contactNumber)
  ) {
    validationModel.contactNumber = translate("Phone_Error", "Invalid phone");
  }

  return validationModel;
};
